import { Component } from '@angular/core';
import { BackendHealthService } from '../../services/backend-health.service';

@Component({
  selector: 'app-backend-status-banner',
  templateUrl: './backend-status-banner.component.html',
  styleUrls: ['./backend-status-banner.component.css']
})
export class BackendStatusBannerComponent {
  isBackendDown$ = this.backendHealth.isBackendDown$;

  constructor(private readonly backendHealth: BackendHealthService) {}

  retry(): void {
    window.location.reload();
  }
}
